import { get } from 'lodash';

export default class Tax {
  static avalara_tax_id = '7ab35032-21fa-11ec-a72d-12f3f52e1a8f';

  static createdByAvalara(tax) {
    return get(tax, 'created_by') === 'avalara';
  }
}
